import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  cardsContainerLarge: {
    flex: 0.9,
    marginHorizontal: 25,
    marginTop: hp('5%'),
    marginBottom: hp('2%'),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumnLarge: {
    flex: 1,
    marginHorizontal: 25,
  },
  cardsContainerMedium: {
    flex: 0.9,
    marginHorizontal: 15,
    marginTop: hp('5%'),
    marginBottom: hp('2%'),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumnMedium: {
    flex: 1,
    marginHorizontal: 10,
  },
  cardHeaderLarge: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
  },
  cardHeaderMedium: {
    minHeight: 180,
    paddingVertical: 30,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
  },
  textLarge: {
    textTransform: 'uppercase',
    color: '#FFFFFF',
    fontSize: 64,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  textMedium: {
    textTransform: 'uppercase',
    color: '#FFFFFF',
    fontSize: 50,
    fontWeight: '700',
    lineHeight: 50,
    letterSpacing: 0.25,
    textAlign: 'center',
  },

  textSmall: {
    textTransform: 'uppercase',
    color: '#FFFFFF',
    fontSize: 45,
    fontWeight: '700',
    lineHeight: 50,
    letterSpacing: -1.25,
    textAlign: 'center',
  },
  selectedText: {
    color: '#0F6657',
    fontSize: 12,
    fontWeight: '700',
  },
  posterLarge: {
    display: 'flex',
    flexDirection: 'row',
    padding: 40,
  },
  textPosterLargeContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    width: '100%',
    marginRight: wp('15%'),
  },

  textPosterMediumContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    width: '100%',
    marginRight: wp('4%'),
  },
  textPosterLarge: {
    color: '#fff',
    flex: 0.52,
    textAlign: 'left',
    fontSize: 60,
    fontWeight: '700',
    justifyContent: 'center',
    lineHeight: 20,
    letterSpacing: 0.25,
    minWidth: 'max-content',
    marginRight: 50,
  },

  textPosterMedium: {
    color: '#fff',
    flex: 0.52,
    textAlign: 'left',
    fontSize: 50,
    fontWeight: '700',
    justifyContent: 'center',
    lineHeight: 20,
    letterSpacing: 0.25,
    minWidth: 'max-content',
    marginRight: 30,
  },
  textPosterSmall: {
    color: '#fff',
    flex: 0.52,
    textAlign: 'left',
    fontSize: 40,
    fontWeight: '700',
    justifyContent: 'center',
    lineHeight: 20,
    letterSpacing: -1.25,
    minWidth: 'max-content',
    marginRight: 30,
  },
  goBackContainerLarge: {
    flex: 0.2,
    alignSelf: 'center',
    justifyContent: 'center',
    overflow: 'visible',
  },
});
